import colors from "assets/theme/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

const { text, background } = colors;

const select = {
  styleOverrides: {
    select: {
      "&&": {
        color: text.main,
        // deja espacio a la derecha para el ícono
        paddingRight: `${pxToRem(36)} !important`,
        paddingLeft: `${pxToRem(12)} !important`,
        // opcional: mantiene el fondo cuando está abierto o en foco
        backgroundColor: `${background.paper} !important`,
      },
      "&&:focus": {
        backgroundColor: `${background.paper} !important`,
      },
      "&&[aria-expanded='true']": {
        backgroundColor: `${background.paper} !important`,
      },
    },
    // ← fuerza que el ícono exista, sea visible y esté bien posicionado
    icon: {
      right: pxToRem(8),
      color: text.secondary,
      opacity: 1,
      visibility: "visible",
      display: "inline-flex",
      pointerEvents: "none",
    },
  },
};

export default select;
